import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { AISummaryAnswer } from "./ai-summary-answer";
import {
    AISummaryContextProvider,
    useAISummaryContext,
    Source
} from "./ai-summary-context";
import { AISummaryLoadingAnimation } from "./ai-summary-loading-animation";
import { AIAnswerSearchBorder } from "./styled";

export type { Source };

export const AISummary = ({ query }: { query: string }) => {
    return (
        <AISummaryContextProvider query={query}>
            <AISummaryContent />
        </AISummaryContextProvider>
    );
};

export const AISummaryContent = () => {
    const { isLoading, traceResponse } = useAISummaryContext();

    const isLoadingOrTraceResponse = Boolean(isLoading || traceResponse);

    return (
        <div
            css={css({
                display: "flex",
                flexDirection: "column",
                gap: token("space.100")
            })}
        >
            <AIAnswerSearchBorder
                isLoading={isLoadingOrTraceResponse}
                isStreaming={!!traceResponse}
            >
                <div css={aiSummaryBoxStyle}>
                    {isLoadingOrTraceResponse && (
                        <AISummaryLoadingAnimation
                            traceResponse={traceResponse}
                        />
                    )}
                    {!isLoadingOrTraceResponse && <AISummaryAnswer />}
                </div>
            </AIAnswerSearchBorder>
        </div>
    );
};

const aiSummaryBoxStyle = css({
    padding: token("space.150"),
    width: "100%",
    position: "relative"
});
